import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use this page to set up an LTI connection between GMetrix and your <strong>Learning Management System</strong> (LMS). Start with the LTI 1.3 option that matches your LMS, and use LTI 1.1 only when LTI 1.3 is not supported." id="use_this_page_to_set_up_an_lti_connectio.8cb7d3a1" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="LTI Integration" id="lti_integration.1aeb2664" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Pick the registration type that matches your LMS: <strong>Dynamic Registration</strong> (Canvas, D2L Brightspace, Moodle), <strong>Client ID Registration</strong> (Blackboard), or <strong>Manual Registration</strong> (Canvas, Moodle). Copy the values shown, register GMetrix in your LMS, then return here to enter any IDs your LMS generates." id="pick_the_registration_type_that_matches.008ddf31" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Choose a registration type" id="choose_a_registration_type.73dec085" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="For <strong>LTI 1.1</strong>, copy the <strong>Consumer Key</strong>, <strong>Shared Secret</strong>, and <strong>Launch URL</strong> into your LMS to configure the connection." id="for_lti_11_copy_the_consumer_key_shared.b61eb33a" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="LTI 1.1 credentials" id="lti_11_credentials.ec464867" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="To launch a specific practice test or course without deep linking, use <strong>Link to a specific resource</strong> to choose a resource and access code, then copy the generated custom parameters into your LMS tool configuration." id="to_launch_a_specific_practice_test_or_co.d7105b6e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Linking a specific resource" id="linking_a_specific_resource.c629b5dd" />
        }
    ],
    title: <FormattedMessage defaultMessage="Integrations" id="integrations.89572b90" />
};
